(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name userService
     *@description
     *Servicio de Usuarios
     */

    angular
        .module('app')
        .factory('userService', userService);

    userService.$inject = ["$http","$q","$window","$location"];

    function userService($http,$q,$window,$location) {    

    	var user = {};

        user.likeCentre = function(id)
        {
            if(!user.favorits)
                return false;
            var b = false;
            for (var i = 0; i < user.favorits.length; i++) {
                if(user.favorits[i].centre_id == id)
                    b=true;
            }
            return b;
        };
        user.likeEspai = function(id)
        {
            if(!user.favorits)
                return false;
            var b = false;
            for (var i = 0; i < user.favorits.length; i++) {
                if(user.favorits[i].espai == id)
                    b=true;
            }
            return b;
        };

        user.likeAutor = function(id)
        {
            if(!user.favorits)
                return false;
            var b = false;
            for (var i = 0; i < user.favorits.length; i++) {
                if(user.favorits[i].autor == id)
                    b=true;
            }
            return b;
        };

    	/**
        * @ngdoc method
        * @name islogged
        * @memberof userService
        * @desciption
        * dice si un usuario esta logueado
        */


    	user.islogged = function()
    	{
    		return (user.info);
    	};

    	/**
        * @ngdoc method
        * @name login
        * @memberof userService
        * @desciption
        * loguea a un usuario
        */
    	user.login = function (username,password){
            var url= '/api/v1/login';
             return $http({
                method  : 'POST',
                url     : url,
                data	: $.param({
                	"username":username,
                	"password":password
                })
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  
            	
                if(data.data.code == 200){
                   console.log(data.data);
                   user.favorits = data.data.favorits;
                   user.info = data.data.user;
                   sessionStorage.mapa_token = user.info.token; 
                }                   
                return data.data;
            }

            function Failed(data){
                console.log(data);
                return false;
            }
        };

        /**
        * @ngdoc method
        * @name registre
        * @memberof userService
        * @desciption
        * registre a un usuario
        */
    	user.registre = function (username,password,nom,cognoms){
            var url= '/api/v1/register';
             return $http({
                method  : 'POST',
                url     : url,
                data	: $.param({
                	"username":username,
                	"password":password,
                	"nom":nom,
                	"cognoms":cognoms
                })
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  
            	console.log(data.data);
                if(data.data.code ==200){
                    user.favorits = data.data.favorits;
            	   user.info = data.data.user;
            	   sessionStorage.mapa_token = user.info.token;
                }
                return data.data;
            }

            function Failed(data){
                console.log(data);
                return false;
            }
        };


        /**
        * @ngdoc method
        * @name configuracio
        * @memberof userService
        * @desciption
        * configuracio a usuario
        */
        user.configuracio = function (username,password,nom,cognoms,email,work,state){
            var url= '/api/v1/profile';
             return $http({
                method  : 'POST',
                url     : url,
                data    : $.param({
                    "token":sessionStorage.mapa_token,
                    "username":username,
                    "password":password,
                    "nom":nom,
                    "cognoms":cognoms,
                    "email":email,
                    "work":work,
                    "state":state
                })
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  
                console.log(data.data);
                user.info = data.data.user;
                return data.data.user;
            }

            function Failed(data){
                console.log(data);
                return false;
            }
        };

        /**
        * @ngdoc method
        * @name recuperar
        * @memberof userService
        * @desciption
        * recuperar a usuario
        */
        user.recuperar = function (username){
            var url= '/api/v1/recovery-password';
             return $http({
                method  : 'POST',
                url     : url,
                data    : $.param({
                    "username":username,
                })
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  

                return data.data;
            }

            function Failed(data){
                console.log(data);
                return false;
            }
        };


         /**
        * @ngdoc method
        * @name recuperar
        * @memberof userService
        * @desciption
        * recuperar a usuario
        */
        user.setPassword = function (token,password){
            var url= '/api/v1/set-password';
             return $http({
                method  : 'POST',
                url     : url,
                data    : $.param({
                    "token":token,
                    "password":password
                })
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  

                return data.data;
            }

            function Failed(data){
                console.log(data);
                return false;
            }
        };

        /**
        * @ngdoc method
        * @name user_fav
        * @memberof userService
        * @desciption
        * registre a un usuario
        */
        user.user_fav = function (customer,espai,ruta,autor,centre){
            if(!sessionStorage.mapa_token)
                return false;

            var url= '/api/v1/user_favorit';
             return $http({
                method  : 'POST',
                url     : url,
                data    : $.param({
                    "customer":customer,
                    "espai":espai,
                    "ruta":ruta,
                    "autor":autor,
                    "centre":centre
                })
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  
                user.favorits = data.data.favorits;
                return data.data;
            }

            function Failed(data){
                console.log(data);
                return false;
            }
        };
 		/**
        * @ngdoc method
        * @name logout
        * @memberof userService
        * @desciption
        * hace logout.
        */
        user.logout = function()
        {
			sessionStorage.mapa_token = null;
			$location.path("/");
        	$window.location.reload();
        };



        /**
        * @ngdoc method
        * @name user
        * @memberof userService
        * @desciption
        * Obtienes el usuario.
        */
    	user.user  = function (){
            var url= '/api/v1/user';
            console.log(sessionStorage.mapa_token)
            if(!sessionStorage.mapa_token)
            	return false;

             return $http({
                method  : 'GET',
                url     : url,
                params	: {
                	"token":sessionStorage.mapa_token
                }
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  
                user.favorits = data.data.favorits;
            	user.info = data.data.user;
                return data.data.user;
            }

            function Failed(data){
                console.log(data);
                return false;
            }
        };
        


    	return user;
    }



})();
